import FormattedTime from './formatted-time';
import formatTime from './format-time.js';

export default ( FormattedTime );
export { formatTime, FormattedTime };
